import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {AppRoutingModule, routing} from './/app-routing.module';
import {LoginComponent} from './login/login.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AuthorisedTopNavComponent} from './layout/authorised/authorised-top-nav/authorised-top-nav.component';
import {AuthorisedSideNavTogglerComponent} from './layout/authorised/authorised-side-nav-toggler/authorised-side-nav-toggler.component';
import {AuthorisedLayoutComponent} from './layout/authorised/authorised-layout/authorised-layout.component';
import {AuthorisedSideNavComponent} from './layout/authorised/authorised-side-nav/authorised-side-nav.component';
import {AuthorisedSideNavService} from './layout/authorised/services/authorised-side-nav.service';
import {FirmsComponent} from './firms/firms.component';
import {PageContentComponent} from './page-content/page-content.component';
import {AmChartsModule} from '@amcharts/amcharts3-angular';
import {ProductsTypeComponent} from './products-type/products-type.component';
import {UpdatesComponent} from './updates/updates.component';
import {RecordsComponent} from './records/records.component';
import {SupportComponent} from './support/support.component';
import {FirmGroupsComponent} from './firm-groups/firm-groups.component';
import {FirmMenuComponent} from './firm-menu/firm-menu.component';
import {FirmAutomatsComponent} from './firm-automats/firm-automats.component';
import {FirmPayvendComponent} from './firm-payvend/firm-payvend.component';
import {FirmVendcardComponent} from './firm-vendcard/firm-vendcard.component';
import {FirmSimcardComponent} from './firm-simcard/firm-simcard.component';
import {FirmBeaconsComponent} from './firm-beacons/firm-beacons.component';
import {FirmTicketComponent} from './firm-ticket/firm-ticket.component';
import {ProductCategoryComponent} from './product-category/product-category.component';
import {ProductFilterComponent} from './product-filter/product-filter.component';
import {HavingComponent} from './having/having.component';
import {HavingFirmComponent} from './having-firm/having-firm.component';
import {HavingTypeComponent} from './having-type/having-type.component';
import {AuthenticateService} from './services/authenticate.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthGuard} from './core/guards/auth.guard';
import {FirmService} from './services/firm.service';
import {AutomatService} from './services/automat.service';
import {SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import {SimcardService} from './services/simcard.service';
import {BeaconService} from './services/beacon.service';
import {FirmGroupService} from './services/firm-group.service';
import {FirmModemComponent} from './firm-modem/firm-modem.component';
import {ModemService} from './services/modem.service';
import {PayvendService} from './services/payvend.service';
import {NgxSpinnerModule} from 'ngx-spinner';
import {FirmDeviceComponent} from './firm-device/firm-device.component';
import {DeviceService} from './services/device.service';
import {AddAutomatComponent} from './add-automat/add-automat.component';
import {AgmCoreModule} from '@agm/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EditAutomatComponent} from './edit-automat/edit-automat.component';
import {Ng2SearchPipeModule} from 'ng2-search-filter';
import {AllAutomatsComponent} from './all-automats/all-automats.component';
import {NgxLoadingModule} from 'ngx-loading';
import {FirmUsersComponent} from './firm-users/firm-users.component';
import {FirmUsersService} from './services/firm-users.service';
import {UsersComponent} from './users/users.component';
import {AutomatKindService} from './services/automat-kind.service';
import {BrandComponent} from './brand/brand.component';
import {BrandService} from './services/brand.service';
import {PipesModule} from './pipes/pipes.module';
import {ImageService} from './services/image.service';
import {ProductService} from './services/product.service';
import {ImageCropperModule} from 'ngx-image-cropper';
import {CategoryService} from './services/category.service';
import {CategoriesComponent} from './categories/categories.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {StaffService} from './services/staff.service';
import {AutomatBrandsComponent} from './automat-brands/automat-brands.component';
import {AutomatBrandService} from './services/automat-brand.service';
import {AutomatBrandDetailComponent} from './automat-brand-detail/automat-brand-detail.component';
import {AutomatModelService} from './services/automat-model.service';
import {AddProductComponent} from './add-product/add-product.component';
import {ProductTagComponent} from './product-tag/product-tag.component';
import {TagService} from './services/tag.service';
import {NgSelectModule} from '@ng-select/ng-select';

import {TokenInterceptor} from '../app/core/http.interceptor';
import {AutomatKindComponent} from './automat-kind/automat-kind.component';
import {GeocodingHelperService} from './helpers/geocoding.helper';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FirmPaymentComponent} from './firm-payment/firm-payment.component';
import {DeviceLogComponent} from './device-log/device-log.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        DashboardComponent,
        AuthorisedTopNavComponent,
        AuthorisedSideNavTogglerComponent,
        AuthorisedLayoutComponent,
        AuthorisedSideNavComponent,
        FirmsComponent,
        PageContentComponent,
        ProductsTypeComponent,
        UpdatesComponent,
        RecordsComponent,
        SupportComponent,
        FirmGroupsComponent,
        FirmMenuComponent,
        FirmAutomatsComponent,
        FirmPayvendComponent,
        FirmVendcardComponent,
        FirmSimcardComponent,
        FirmBeaconsComponent,
        FirmTicketComponent,
        ProductCategoryComponent,
        ProductFilterComponent,
        HavingComponent,
        HavingFirmComponent,
        HavingTypeComponent,
        FirmModemComponent,
        FirmDeviceComponent,
        AddAutomatComponent,
        EditAutomatComponent,
        AllAutomatsComponent,
        FirmUsersComponent,
        UsersComponent,
        BrandComponent,
        CategoriesComponent,
        AutomatBrandsComponent,
        AutomatBrandDetailComponent,
        AddProductComponent,
        ProductTagComponent,
        AutomatKindComponent,
        FirmPaymentComponent,
        DeviceLogComponent
    ],
    imports: [
        PipesModule,
        BrowserModule,
        AppRoutingModule,
        routing,
        BrowserAnimationsModule,
        AmChartsModule,
        InfiniteScrollModule,
        HttpClientModule,
        SweetAlert2Module.forRoot(),
        NgxSpinnerModule,
        NgxLoadingModule.forRoot({}),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBzU7oDFOIKAdDF9lMYB9qdyeSCV_hjdfI'
        }),
        FormsModule,                               // <========== Add this line!
        ReactiveFormsModule,
        Ng2SearchPipeModule,
        ImageCropperModule,
        NgSelectModule,
        NgbModule.forRoot()
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
          },
        AuthGuard,
        AuthorisedSideNavService,
        AuthenticateService,
        FirmService,
        AutomatService,
        SimcardService,
        BeaconService,
        FirmGroupService,
        ModemService,
        PayvendService,
        DeviceService,
        FirmUsersService,
        AutomatKindService,
        BrandService,
        ImageService,
        ProductService,
        CategoryService,
        StaffService,
        AutomatBrandService,
        AutomatModelService,
        TagService,
        GeocodingHelperService,
        NgbActiveModal
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/app.module.ts